import NotificationListContainer from './NotificationListContainer';

export default NotificationListContainer;
